import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {FreeMode} from "swiper";
import {Autoplay, Pagination, Navigation} from "swiper";
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import Metrika from './Metrika';

import 'bootstrap/dist/css/bootstrap.min.css';

import Card1 from './Card1';

import { NavItem } from 'react-bootstrap';

function importAll(r) {
    return r.keys().map(r);
  }
  
  const images = importAll(require.context('../img/brus/', false, /\.(png|jpe?g|svg)$/));


const Sliderbrus = () => {
    return (

        <div className="container py-4 px-4 justify-content-center">
            <h1 style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}}>Производство: Брус простой и Брус профилированный.</h1>

<div  style={{
            textAlign: 'center',
            color: '#000000',
            alignSelf: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            textAlignVertical: 'center',
            alignContent: 'center',
            fontSize: '18px',
          }}>В стоимость входит материал + доставка + установка под рубероид.<br  />
Профилированный брус изготавливается из лиственницы, сосны, ели, пихты или кедра.
            Из лиственных пород используется дуб, береза, осина, ясень и бук.
            Любой размер и профиль под заказ.
            Доска пола, имитация бруса, блокхаус, вагонка, строганая доска.</div><br  />

            <Swiper
                autoplay={{delay: 2500}}
                modules={[Autoplay, Pagination, Navigation, FreeMode]}
                freeMode={true}
                grabCursor={true}
                className="mySwiper"
                slidesPerView={2}
                spaceBetween={5}
                navigation={true}
                                 
            >
                   
        {images.map((img, i) => {
          return (
            <SwiperSlide key={i}>
              <img src={img} alt="" width="100%" />
            </SwiperSlide>
          );
        })}
        
            </Swiper><br  />
            <Metrika />
        </div>
    );
};

export default Sliderbrus;